var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.14428 16.3823C10.5007 16.3823 11.8266 15.9801 12.9545 15.2265C14.0823 14.4729 14.9613 13.4018 15.4804 12.1487C15.9995 10.8955 16.1353 9.51656 15.8707 8.18621C15.606 6.85586 14.9529 5.63385 13.9937 4.67472C13.0346 3.71559 11.8126 3.06242 10.4822 2.7978C9.15189 2.53317 7.77294 2.66899 6.51978 3.18806C5.26662 3.70714 4.19552 4.58617 3.44194 5.71398C2.68836 6.8418 2.28613 8.16775 2.28613 9.52417C2.28613 10.658 2.56046 11.7272 3.04815 12.669L2.28613 16.3823L5.99944 15.6203C6.94129 16.108 8.01116 16.3823 9.14428 16.3823Z",
    stroke: "#999999",
    strokeWidth: 1.52403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.566cbb2eff5523799f9fced20c3ff0a5.svg";
export { ForwardRef as ReactComponent };